import React from "react";
import "./MiniCart.css";
import Heading from "../Heading/Heading";
import SideCartList from "../Sidecart_ItemList/SideCartList";
import DiscountForm from "../DiscountForm/DiscountForm";
import { connect } from "react-redux";
import { useEffect } from "react";
import { subtotal_calculator } from "../../Utility/Utility";
import { useState } from "react";
import { removeItemFromCart } from "../../Redux/cartReducer/cartActions";

const MiniCart = ({ cart, setOrderObj , removeItemFromCart}) => {
  const [subtotal, setSubtotal] = useState(0);
  const [shippingCost, setShippingCost] = useState(100);
  const [cartArray, setcartArray] = useState([]);
  useEffect(() => {
    if (cart.length) {
      var subtotal = subtotal_calculator(cart);
      setSubtotal(subtotal);
      var cartItemsArray = [];
      cart.forEach((cartItem) => {
        cartItemsArray.push({
          productId: cartItem.productId,
          quantity: cartItem.quantity,
          selectedColors: cartItem.color,
        });
      });
      setcartArray(cartItemsArray);
    }
  }, [cart]);
  useEffect(() => {
    if (cart.length) {
      setOrderObj((prevValue) => ({
        ...prevValue,
        subtotal,
        shippingCost,
        orderedItems: cartArray,
      }));
    }
  }, [cart, subtotal, shippingCost]);
  return (
    <div className="mini-cart">
      <div className="mini-cart-main">
        <Heading>Your Cart</Heading>
        <div className="mini-cart-list-items">
          <SideCartList cart={cart} removeItemFromCart={removeItemFromCart}/>
        </div>
        <div className="discount-form-container flex-center">
          <DiscountForm />
        </div>
        <div className="amounts">
          <div className="st">
            <Heading>Subtotal</Heading>
          </div>
          <div className="st-am">
            <Heading>Rs {subtotal}</Heading>
          </div>
          <div className="sh">
            <Heading>Shipping</Heading>
          </div>
          <div className="sh-am">
            <Heading>Rs {shippingCost}</Heading>
          </div>
        </div>
        <div className="tot">
          <Heading>Total</Heading>
          <Heading>Rs {subtotal + shippingCost}</Heading>
        </div>
      </div>
    </div>
  );
};
var mapState = (state) => ({
  cart: state.cart,
});
var actions = {
    removeItemFromCart
}
export default connect(mapState,actions)(MiniCart);
